import React from 'react'
import styled from 'styled-components'
import FormatNumber from 'react-number-format'

type DisplayProps = {
    type: 'phone'
    children: string
}

const FORMATS: { [key in DisplayProps['type']]: string } = {
    phone: '+# (###) ###-####',
}

export const NumberDisplay = (props: DisplayProps): JSX.Element => {
    const { type, children } = props

    return (
        <Container>
            <FormatNumber displayType="text" format={FORMATS[type]} value={children} />
        </Container>
    )
}

const Container = styled.div``
